import { render, staticRenderFns } from "./add-user-facility.vue?vue&type=template&id=0202b4b8&scoped=true"
import script from "./add-user-facility.vue?vue&type=script&lang=js"
export * from "./add-user-facility.vue?vue&type=script&lang=js"
import style0 from "./add-user-facility.vue?vue&type=style&index=0&id=0202b4b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0202b4b8",
  null
  
)

export default component.exports